(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nerdshop-collection-header"]) return;
  try {
    
  class NerdshopSubcollections extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (this.controller) return;
      this.disclosure = this.querySelector('[data-subcollection-disclosure]');
      this.dialog = this.querySelector('[data-subcollection-dialog]');
      this.panel = this.querySelector('[data-subcollection-panel]');
      if (!this.disclosure || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger = this.disclosure.querySelector('summary');
      this.input = this.panel.querySelector('[data-subcollection-input]');
      this.items = Array.from(this.panel.querySelectorAll('[data-subcollection-result]'));
      this.count = this.panel.querySelector('[data-subcollection-count]');
      this.empty = this.panel.querySelector('[data-subcollection-empty]');
      this.search = this.panel.querySelector('[data-subcollection-search]');
      this.closeButton = this.panel.querySelector('[data-subcollection-close]');
      this.dialog.append(this.panel);
      this.disclosure.dataset.enhanced = 'true';
      this.trigger.setAttribute('aria-haspopup', 'dialog');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.search.hidden = false;
      this.closeButton.hidden = false;
      this.items.forEach(item => { item.searchText = this.normalize(item.dataset.search); });
      this.filter();

      this.trigger.addEventListener('click', event => {
        event.preventDefault();
        this.input.value = '';
        this.filter();
        if (!this.dialog.open) this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        this.input.focus({ preventScroll: true });
      }, options);
      this.input.addEventListener('input', () => this.filter(), options);
      this.closeButton.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.isConnected) this.trigger.focus({ preventScroll: true });
      }, options);
    }

    normalize(value) {
      return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }

    filter() {
      const terms = this.normalize(this.input.value).split(/\s+/).filter(Boolean);
      let matches = 0;
      this.items.forEach(item => {
        const visible = terms.every(term => item.searchText.includes(term));
        item.hidden = !visible;
        if (visible) matches += 1;
      });
      this.count.textContent = matches + ' ' + (matches === 1 ? this.dataset.singleLabel : this.dataset.pluralLabel);
      this.empty.hidden = matches !== 0;
      this.panel.querySelector('.ns-subcollections__grid').hidden = matches === 0;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
    }
  }

  if (!customElements.get('nerdshop-subcollections')) customElements.define('nerdshop-subcollections', NerdshopSubcollections);

  } catch(e) { console.error(e); }
})();
})();
